module.exports = __webpack_public_path__ + "footable.91c343856c56695b4599.eot";


//////////////////
// WEBPACK FOOTER
// /app/vendor/footable/fonts/footable.eot
// module id = ../../../../../vendor/footable/fonts/footable.eot
// module chunks = styles